import { render, staticRenderFns } from "./FAQEditor.vue?vue&type=template&id=14b7b339&"
import script from "./FAQEditor.vue?vue&type=script&lang=js&"
export * from "./FAQEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports